<template>
    <b-modal
        :id="id"
        :title="title ? title : (document_folder ? 'Update ' + document_folder.name : 'Add a new folder')"
        size="lg"
    >
        <div v-if="!parent_folder_id">
            <c-select label="Parent Folder" :options="document_folder_opts" :value.sync="selected_folder_id" :horizontal="true" />
        </div>
        <c-input label="Name" v-model="folder_name" :horizontal="true"></c-input>
        <font-awesome-picker v-model="folder_icon"></font-awesome-picker>
        <template v-slot:modal-footer>
            <b-button-group>
                <b-button variant="outline-success" squared @click="save"><font-awesome-icon :icon="['fal', 'save']"></font-awesome-icon></b-button>
            </b-button-group>
        </template>
    </b-modal>
</template>

<script>
  import ToastNotifications from "../shared/mixins/ToastNotifications";
  import DocumentFolder from "../../models/DocumentFolder";
  import FontAwesomePicker from "./FontAwesomePicker";

  export default {
    name: 'DocumentFolderModal',
    components: {FontAwesomePicker},
    props: {
      parent_folder_id: {
        default: function () {
          return null;
        }
      },
      document_folder: {
        default: function () {
          return null;
        }
      },
      id: {
        default: function () {
          return 'document-folder-modal-' + Date.now();
        }
      },
      title: {
        default: function () {
          return null;
        }
      },
    },
    mixins: [ToastNotifications],
    data() {
      return {
        document_folders: null,
        document_folder_opts: null,
        selected_folder_id: null,
        folder_name: null,
        folder_icon: null,
      };
    },
    methods: {
      save() {
        let payload = {
          name: this.folder_name,
          icon: this.folder_icon,
          parent_folder_id: this.selected_folder_id,
        };
        let request = null;
        if(this.document_folder) {
          if(!payload.parent_folder_id && this.document_folder.parent_folder_id) {
            payload.parent_folder_id = this.document_folder.parent_folder_id;
          }
          request = DocumentFolder.api().update(this.document_folder.id, payload);
        } else {
          request = DocumentFolder.api().create(payload);
        }
        return request.then((response) => {
          let document_folder = null;
          response.entities.document_folders.forEach((folder) => {
            if(folder.id !== this.selected_folder_id) {
              document_folder = folder;
            }
          });
          if(!this.document_folder) {
            this.selected_folder_id = null;
            this.folder_name = null;
            this.folder_icon = null;
          }
          this.$bvModal.hide(this.id);
          this.$emit('onSave', document_folder);
          return document_folder;
        });
      },
      fetchDocumentFolders() {
        let params = {};
        /*if(this.parent_folder_id) {
          this.selected_folder_id = this.parent_folder_id;
          params.parent_folder_id = this.parent_folder_id;
        }*/
        params.private = 0;
        return DocumentFolder.api().fetch(params).then(() => {
          let query = DocumentFolder.query();
          /*if(this.parent_folder_id) {
            query.where('parent_folder_id', this.parent_folder_id);
          }*/
          if(this.document_folder) {
            query.where((folder) => {
              return folder.id !== this.document_folder.id
            });
          }
          let folders = query.where('private', 0).get();
          if(!folders) {
            folders = [];
          }
          this.document_folders = folders;
          this.document_folder_opts = [{value: null, label: 'No Parent Folder'}];
          this.document_folders.forEach((folder) => {
            this.document_folder_opts.push({value: folder.id, label: folder.name});
          });
          this.loading = false;
          return this.loading;
        });
      }
    },
    created() {
      if(this.parent_folder_id) {
        this.selected_folder_id = this.parent_folder_id;
      }
      if(this.document_folder) {
        this.selected_folder_id = this.document_folder.parent_folder_id;
        this.folder_name = this.document_folder.name;
        this.folder_icon = this.document_folder.icon;
      }
      this.fetchDocumentFolders();
    }
  }
</script>